import React, { Component } from 'react';
import {Button, Modal} from 'antd';
import {request, secToTime} from "../utils/Util";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import * as actions from "../actions/evaluation";
import Question from "../question/Question";
class Time extends Component{
    constructor(props) {
        super(props);
        this.state = {
            timeText: '30:00',
            time: 1800,
        }
    }

    intervalTime = ()=>{
        if(this.state.time > -1){
            setInterval(this.startTime,1000)
        }else{
            clearInterval();
            this.setState({
                timeText: '00:00',
                time: 0,
            })
        }
    }

    startTime = ()=>{
        var time = this.state.time-1;
        this.setState({
            time: time,
            timeText : secToTime(this.state.time)
        });
    }

    async getData(){
        const {match} = this.props;
        console.log(match,'hhhh- ------ ---- --')
        var params = {entity_id: match.params.type};
        const questions = await request(`/questionnaires/node__content_object/`,'get',params);
        console.log(questions,'数九22222222');

        var state = {};
        var currnt = questions.detail.results[0].content_object_content ? questions.detail.results[0].content_object_content.units[0] : null;
        if (currnt && currnt.test === 'math') { // 单选填空题
            state = {
                timeText: '60:00',
                time: 3600
            };

        }else if( currnt && currnt.test === 'science'){
            state = {
                timeText: '35:00',
                time: 2100
            };
        }else if( currnt && currnt.test === 'english'){
            state = {
                timeText: '45:00',
                time: 2700
            };
        }else if( currnt && currnt.test === 'reading'){
            state = {
                timeText: '35:00',
                time: 2100
            };
        }
        this.setState({
            timeText: state.timeText,
            time: state.time
        },()=>{
            this.intervalTime();
        })

    }

    setTime(){
        const {evaluation} = this.props;

        var state = {
            timeText: '30:00',
            time: 1800,
        };


        this.setState({
            timeText: state.timeText,
            time: state.time
        },()=>{
            this.intervalTime();
        })
    }

    componentDidMount() {
        this.getData();
        if (this.props.setRef) {
            this.props.setRef(this)
        }
    }

    render() {
        const {evaluation} = this.props;
        return (
            <Button>
                {this.state.timeText}
            </Button>
        );
    }
}

Time = connect((state) => ({
    evaluation: state.evaluation,
}), (dispatch) => ({
}))(Time);

export default Time;